window.LandingPage = {
    init() {
        this.handleAnalytics();
    },

    handleAnalytics() {
        document.addEventListener('analyticsReady', () => {
            analytics.page("", ANALYTICS_EVENTS.LANDING_PAGE_VIEWED, {
                deal_id: document.getElementById("deal_id").value,
            });

            const viewRequestBtns = document.querySelectorAll(".view-request-btn");
            for (var i = 0; i < viewRequestBtns.length; i++) {
                viewRequestBtns[i].addEventListener("click", () => {
                    analytics.track(ANALYTICS_EVENTS.LANDING_PAGE_VIEW_REQUEST_SELECTED, {});
                })
            }

            const loginBtn = document.getElementById("landing-page-login-btn");
            loginBtn.addEventListener("click", () => {
                analytics.track(ANALYTICS_EVENTS.LANDING_PAGE_LOG_IN_SELECTED, {});
            })
            const signup = document.getElementById("landing-page-signup-btn");
            signup.addEventListener("click", () => {
                analytics.track(ANALYTICS_EVENTS.LANDING_PAGE_SIGN_UP_SELECTED, {});
            })
        });
    }
}
